import React from 'react';
import { t, Trans } from '@lingui/macro';
import { Dialog } from '@economic/taco';

import ExternalLink from '~/app/shared/components/ExternalLink';
import { SubscriptionChangeSuccessFooter } from '~/app/pages/settings/company/subscription/SubscriptionChangeSuccessComponents/SubscriptionChangeSuccessFooter';
import Artboard from '../Artboard.png';

interface Props {
    readMoreLink?: string;
    redirectOnClose?: string;
}

export default function SmartPlanSubscriptionChangeSuccessContent({ readMoreLink, redirectOnClose }: Props) {
    return (
        <Dialog.Content aria-label={t`You have now upgraded to the Smart Package`}>
            <Dialog.Title>
                <Trans>You have now upgraded to the Smart Package</Trans>
            </Dialog.Title>
            <div className="flex justify-center items-center pb-16 pt-12">
                <img className="w-64" src={Artboard} />
            </div>
            <div className="whitespace-pre-wrap">
                <p>
                    <Trans>
                        With the Smart Package, you have access to features that make your workday even more simple and efficient.
                        Explore the possibilities of your new package and make sure you get the full value of the upgrade.
                    </Trans>
                </p>
                {readMoreLink && (
                    <p>
                        <ExternalLink href={readMoreLink}>
                            <Trans>Explore the Smart Package</Trans>
                        </ExternalLink>
                    </p>
                )}
            </div>
            <SubscriptionChangeSuccessFooter redirectOnClose={redirectOnClose} />
        </Dialog.Content>
    );
}
